import Choices from 'choices.js'

// document.addEventListener('DOMContentLoaded', function() {
//   if (!isMobileDevice()) {

//   }
// });

function isMobileDevice() {
  return (
    typeof window.orientation !== 'undefined' ||
    navigator.userAgent.indexOf('IEMobile') !== -1
  )
}

const config = {
  searchEnabled: false,
  shouldSort: false,
  itemSelectText: '',
  allowHTML: true,
  classNames: {
    containerOuter: 'choices rounded-[10px] group',
    containerInner:
      'choices__inner h-10 min-h-0 lg:h-[48px] bg-white-100 rounded-t-[10px] rounded-b-[10px] border-white-400 hover:border-aqua-600 !px-3.5 !py-2.5 lg:!px-4 lg:!py-3 group-[.is-flipped]:rounded-[10px] group-[:not(.is-flipped)]:rounded-[10px] ',
    input: 'choices__input',
    inputCloned: 'choices__input--cloned',
    list: 'choices__list',
    listItems: 'choices__list--multiple',
    listSingle: 'choices__list--single block p-0 relative ',
    listDropdown: 'choices__list--dropdown',
    item: 'choices__item text-sm lg:text-base text-black-500 rounded-lg !pr-[10px]',
    itemSelectable: 'choices__item--selectable',
    itemDisabled: 'choices__item--disabled',
    itemOption: 'choices__item--choice',
    placeholder: 'choices__placeholder',
    group: 'choices__group',
    groupHeading: 'choices__heading',
    button: 'choices__button',
    activeState: 'is-active',
    focusState: 'is-focused',
    openState: 'is-open',
    disabledState: 'is-disabled',
    selectedState: 'is-selected',
    flippedState: 'is-flipped',
    selectedState: 'is-highlighted',
  },
}
const serviceSelects = document.querySelectorAll('.rooms-select')

serviceSelects.forEach((element, index) => {
  const choices = new Choices(element, config)
  choices.setChoices(
    [
      {
        value: 'Pokój 1 osobowy',
        label: 'Pokój 1 osobowy',
      },
      {
        value: 'Pokój 2 osobowy',
        label: 'Pokój 2 osobowy',
      },
      {
        value: 'Pokój 3 osobowy',
        label: 'Pokój 3 osobowy',
      },
      {
        value: 'Pokój 4 ososbowy',
        label: 'Pokój 4 ososbowy',
      },
      {
        value: 'Studio 2 pokojowe',
        label: 'Studio 2 pokojowe',
      },
    ],
    'value',
    'label',
    true
  )

  const inputExecutionTimeElements = document.getElementsByName('rooms_select')
  const inputExecutionTime = inputExecutionTimeElements[index]

  choices.passedElement.element.addEventListener(
    'change',
    function (e) {
      let target = e.target
      inputExecutionTime.value = target.value

      if (inputExecutionTime.value !== '') {
        var event = new Event('input', {
          bubbles: true,
        })
        inputExecutionTime.dispatchEvent(event)
      }
    },
    false
  )
  // }
})
